// extracted by mini-css-extract-plugin
module.exports = {"CommonDisclaimer":"_1vt0v","CommonDisclaimer__Text":"Qfsj1"};